import { render } from "./RICategoriesList.vue?vue&type=template&id=a3ab08ac&scoped=true"
import script from "./RICategoriesList.vue?vue&type=script&lang=js"
export * from "./RICategoriesList.vue?vue&type=script&lang=js"

import "./RICategoriesList.vue?vue&type=style&index=0&id=a3ab08ac&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3ab08ac"]])

export default __exports__